import React from 'react'
import { CATEGORY_GROUPS, CATEGORY_GROUP_ORDER, PRODUCT_TYPES } from '../../utils/constants'

function CategoryDropdown({ value, onChange, onBlur, grouped = true, hasError = false }) {
  const handleChange = (e) => {
    onChange(e.target.value)
    if (onBlur) onBlur()
  }

  const className = hasError ? 'category-select has-error' : 'category-select'

  if (!grouped) {
    return (
      <select
        value={value || ''}
        onChange={handleChange}
        className={className}
      >
        <option value="">— Select —</option>
        {PRODUCT_TYPES.map(type => (
          <option key={type} value={type}>{type}</option>
        ))}
      </select>
    )
  }

  return (
    <select
      value={value || ''}
      onChange={handleChange}
      className={className}
    >
      <option value="">— Select Category —</option>
      {CATEGORY_GROUP_ORDER.map(groupName => (
        <optgroup key={groupName} label={groupName}>
          {CATEGORY_GROUPS[groupName].map(type => (
            <option key={type} value={type}>{type}</option>
          ))}
        </optgroup>
      ))}
    </select>
  )
}

export default CategoryDropdown
